import { storage } from '@/utils/storage'

const REC_KEY = 'widget-ui:rec'
const VIEWED_KEY = 'widget-ui:viewed'
const URL_PARAM = 'aiq_rec'

// Dutchie embedded menus deep-link via ?dtche[product]=slug. Extra query params
// (or URLSearchParams re-encoding of brackets) break their client router.
const DUTCHIE_EMBED_PRODUCT_RE = /[?&#]dtche(%5B|\[)/i

export function initAttribution(): void {
  try {
    const params = new URLSearchParams(window.location.search)
    const recId = params.get(URL_PARAM)
    if (recId) {
      persistRecId(recId)
    }
  } catch {
    // URL parsing failed
  }
}

export function getRecId(): string | null {
  return storage.get<string>(REC_KEY) ?? null
}

export function getViewedProducts(): string[] {
  return storage.get<string[]>(VIEWED_KEY) ?? []
}

export function addViewedProduct(productId: string): void {
  if (!getRecId()) return
  const viewed = getViewedProducts()
  if (!viewed.includes(productId)) {
    viewed.push(productId)
    storage.set(VIEWED_KEY, viewed)
  }
}

export function clearAttribution(): void {
  storage.remove(REC_KEY)
  storage.remove(VIEWED_KEY)
}

export function getAttributionDetails(): Record<string, unknown> {
  return {
    aiq_rec: getRecId(),
    aiq_viewed: getViewedProducts(),
  }
}

export function persistRecId(recId: string): void {
  const existing = getRecId()
  if (existing !== recId) {
    storage.remove(VIEWED_KEY)
  }
  storage.set(REC_KEY, recId)
}

export function isDutchieEmbedProductUrl(url: string): boolean {
  return DUTCHIE_EMBED_PRODUCT_RE.test(url)
}

export function buildAttributedUrl(baseUrl: string, recId: string): string {
  if (isDutchieEmbedProductUrl(baseUrl)) {
    return baseUrl
  }

  try {
    new URL(baseUrl, typeof window !== 'undefined' ? window.location.origin : 'https://localhost')
  } catch {
    return baseUrl
  }

  const encoded = encodeURIComponent(recId)
  const hashIdx = baseUrl.indexOf('#')
  const hash = hashIdx >= 0 ? baseUrl.slice(hashIdx) : ''
  let withoutHash = hashIdx >= 0 ? baseUrl.slice(0, hashIdx) : baseUrl

  withoutHash = withoutHash
    .replace(new RegExp(`([?&])${URL_PARAM}=[^&]*`, 'g'), '$1')
    .replace(/[?&]$/, '')
    .replace(/\?&/, '?')
    .replace(/&&+/g, '&')

  const joiner = withoutHash.includes('?') ? '&' : '?'
  return `${withoutHash}${joiner}${URL_PARAM}=${encoded}${hash}`
}
